import { render, staticRenderFns } from "./CprClaim.vue?vue&type=template&id=2622ce9f"
import script from "./CprClaim.vue?vue&type=script&lang=js"
export * from "./CprClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports